export default __webpack_public_path__ + "static/media/roastBeef.a23e8a5b.png";